export const getAppUrl = () => location.origin.replace('admin', 'app').replace('8080', '3000')

export const copyToClipboard = async (text: string) =>
    navigator.clipboard && window.isSecureContext && navigator.clipboard.writeText(text)
